import { React, useEffect, useState, useMemo } from 'react';
// import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";
import "./index.scss";
import Button from "../../components/ui/Button";

import cybermindrLogo from "../../assets/images/common/cybermindr_logo.svg";

import { oAuthViewDataIcon, oAuthConnectedIcon, oAuthErrorIcon } from "../../utils/icons.js";

import { useSelector, useDispatch } from 'react-redux';
import { authorizeOAuth, resetOAuth } from "../../store/actions/settingsAction.js";

import apiEndpoints from "../../apiEndpoints.js";

const OAuthPge = () => {

    const oAuthResponse = useSelector((state) => state.settings?.oAuthResponse);

    // const { t } = useTranslation();
    const location = useLocation();

    const { params, missingParams } = useMemo(() => {
        const queryParams = new URLSearchParams(location.search);
 
        const params = {
            client_id: queryParams.get('client_id'),
            client_name: queryParams.get('client_name'),
            redirect_uri: queryParams.get('redirect_uri'),
            scope: queryParams.get('scope'),
            state: queryParams.get('state'),
            code_challenge: queryParams.get('code_challenge'),
            code_challenge_method: queryParams.get('code_challenge_method'),
        };

        const requiredKeys = ['client_id', 'client_name', 'redirect_uri', 'scope', 'state'];
 
        const missingParams = requiredKeys.filter(
            (key) => !params[key] || params[key].trim() === ''
        );
 
        return { params, missingParams };
    }, [location.search]);

    const {
        client_id: clientId,
        client_name: clientName,
        redirect_uri: redirectUri,
        scope,
        state: stateId,
        code_challenge: codeChallenge,
        code_challenge_method: codeChallengeMethod,
    } = params;

    const dispatch = useDispatch();

    const [isLoading, setIsLoading] = useState(false);
    const [cancelLoading, setCancelLoading] = useState(false);

    const authorize = (approveType) => {
        const obj = { approved: approveType };
        // Only add params that have a value
        if (clientId) obj.client_id = clientId;
        if (redirectUri) obj.redirect_uri = redirectUri;
        if (scope) obj.scope = scope;
        if (stateId) obj.state = stateId;
        if (codeChallenge) obj.code_challenge = codeChallenge;
        if (codeChallengeMethod) obj.code_challenge_method = codeChallengeMethod;
        if (approveType) {
            setIsLoading(true)
        } else {
            setCancelLoading(true)
        }

        dispatch(authorizeOAuth(obj))
    }

    useEffect(() => {
        if (oAuthResponse !== null) {
            setIsLoading(false)
            setCancelLoading(false)
            window.location.href = oAuthResponse?.redirect_to
            dispatch(resetOAuth())
        }
    }, [oAuthResponse, dispatch])

    const handleGoBack = () => {
        if (window.history.length > 1) {
            window.history.back();
        } else {
            window.location.href = apiEndpoints.appUrl
            // window.close();
        }
    };

    const renderErrorMessage = () => {
        if (missingParams.length === 1) {
            return (
                <>
                    <p className="sub">
                        The request is missing <strong>{missingParams[0]}</strong>, so we can't continue.
                    </p>
                    <div className="code">error: missing_{missingParams[0]}</div>
                </>
            );
        }
 
        return (
            <>
                <p className="sub">
                    The request is missing {missingParams.length} required parameters, so we can't continue.
                </p>
                <ul className="missing-list">
                    {missingParams.map((name) => (
                        <li key={name}>{name}</li>
                    ))}
                </ul>
            </>
        );
    };

    if (missingParams.length > 0) {
        return (
            <div className="oauth-container d-flex align-items-center justify-content-center h-100">
                <div className="card error-card">
                    <div className="icon">
                        {oAuthErrorIcon()}
                    </div>
                    <h1>Couldn't connect</h1>
                    {renderErrorMessage()}
                    <div className="actions">
                        <Button
                            buttonType={"secondary"}
                            buttonText={"Go back"}
                            buttonClicked={handleGoBack}
                        />
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="oauth-container d-flex align-items-center justify-content-center h-100">
            <div className="card">
                <div className="header">
                    <div className="logos">
                        <div className="logo logo-app"><img src={`${apiEndpoints.imageUrl.oAuthClientImage}${clientId}`} alt="client" /></div>
                        <div className="dots"><span></span><span></span><span></span></div>
                        <div className="logo logo-you"><img src={cybermindrLogo} alt="logo" /></div>
                    </div>
                    <h1><strong>{clientName}</strong> is requesting to connect to your <strong>Cybermindr</strong> account</h1>
                </div>
                <div className="section-title">This app will be able to</div>
                <div className="scopes">
                    <div className="scope">
                        {oAuthViewDataIcon()}
                        <div className="scope-text">View your Cybermindr data</div>
                    </div>
                    <div className="scope">
                        {oAuthConnectedIcon()}
                        <div className="scope-text">Stay connected until you disconnect</div>
                    </div>
                </div>
                <div className="actions">
                    {isLoading && <Button buttonType={"primary"} buttonText={"Loading..."} disableButton={true} />}
                    {!isLoading && <Button buttonType={"primary"} buttonText={"Authorize"} buttonClicked={() => { authorize(true) }} />}
                    {cancelLoading && <Button buttonType={"secondary"} buttonText={"Loading..."} disableButton={true} />}
                    {!cancelLoading && <Button buttonType={"secondary"} buttonText={"Cancel"} buttonClicked={() => { authorize(false) }} />}
                </div>
            </div>
        </div>
    )
}

export default OAuthPge